import './app-footer.css';
import React, { Component } from 'react';

export class AppFooter extends Component {
    render() {
    	return (
    		<div className="app-footer text-center text-muted">
    			Gecko
    		</div>
    	);
    }
}

export default AppFooter;